angular.module('autoremind.reseller') // no [] allowed since module has already been created
    .controller('autoremind.dashboard.ScreenController', // TODO expect reseller
// Setup dependencies
['$scope', '$log', 'dashboardService', 'dialogs',
    function ($scope, $log, dashboardService, dialog) {
        $log.info('In autoremind.reseller.dashboard.ScreenController');
        $scope.widgets = dashboardService.widgets;
        $scope.widgetsDialog = function () {
            $scope.widgetsDialogIsOpen = true;
            var dialog = dialogs.create('app/dashboard/browse.widgets.dialog.html', 'autoremind.dashboard.browseWidgetsController', {}, { key: false, back: 'static' });
            dialog.result
                .then(function (jobId) {
                $scope.widgetsDialogIsOpen = false;
            }, function () {
                $scope.widgetsDialogIsOpen = false;
            });
        };
    }
])
    .controller('autoremind.dashboard.browseWidgetsController', ['$scope', '$uibModalInstance', 'dashboardService', 'dialogs', function ($scope, $uibModalInstance, dashboardService, dialogs) {
        $scope.dialogHeader = 'Select Widgets';
        $scope.widgets = dashboardService.widgets;
        $scope.closeDialog = function () {
            $uibModalInstance.close();
        };
        $scope.addWidget = function (index) {
            var dialog = dialogs.confirm('Confirm', 'Are you sure that want to add this widget?');
            dialog.result.then(function (button) {
                // Yes
                setTimeout(function () {
                    $scope.$apply(function () {
                        $scope.widgets[index].visible = true;
                    });
                }, 0);
            }, function (button) {
                // No
                event.preventDefault();
                return;
            });
        };
    }
]);
//# sourceMappingURL=dashboard.controllers.js.map